import { render, staticRenderFns } from "./RiderCreate.vue?vue&type=template&id=6ece7096&lang=pug"
import script from "./RiderCreate.vue?vue&type=script&lang=js"
export * from "./RiderCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports